"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateConventionalMutualFundData = exports.conventionalMutualFundFormRules = exports.conventionalMutualFundFieldMapping = exports.conventionalMutualFundSchema = void 0;
const converters_1 = require("../../converters");
const asset_1 = require("./asset");
exports.conventionalMutualFundSchema = {
    fields: {
        ...asset_1.assetSchema.fields,
        account_number: {
            required: false,
        },
    },
    messages: {
        ...asset_1.assetSchema.messages,
    },
};
// Field mapping between DTO naming and UI naming
exports.conventionalMutualFundFieldMapping = {
    ...asset_1.assetFieldMapping,
};
// 🚀 Pre-computed validations for performance
exports.conventionalMutualFundFormRules = (0, converters_1.toReactHookForm)(exports.conventionalMutualFundSchema, exports.conventionalMutualFundFieldMapping);
exports.validateConventionalMutualFundData = (0, converters_1.createValidator)(exports.conventionalMutualFundSchema);
